export default __webpack_public_path__ + "static/HarmoniaSansPro-Light-f4aaef21514060a909cea649ec9d14f8.woff2";